import { useMediaQuery } from "@mui/material";

export function useIsSmallHorizontalSpacing() {
  return useMediaQuery("(max-width: 350px)");
}
